import { Link } from 'react-router-dom';
import '../styles/inner.css';
import '../styles/management.css';

const sideLinks = [
  { label: 'Management-Team', to: '/management-team', active: false },
  { label: 'Our Peoples',     to: '/our-peoples',     active: true  },
];

const peoples = [
  
  {
    name: 'Mr. Vikram Gupta ',
    role: '(CEO)',
    image: '/images/vikram.gif',
    layout: 'photo-left',
    bio: `Mr. Vikram Gupta (CEO) Management Graduate with over 15 years of experience in operations .`,
  },
  {
    name: 'MR. DEEPAK BANSAL',
    role: '(CHARTERED ACCOUNTANT)',
    image: '/images/JainSira.png',
    layout: 'photo-left',
    bio: `Mr. Deepak Bansal(Chartered Accountant)-with over 3 years of experience.`,
  },
  {
    name: 'MR. PANKAJ KUMAR',
    role: '(HEAD-IT)',
    image: '/images/JainSira.png',
    layout: 'photo-right',
    bio: `Mr. Pankaj Kumar(Head-IT) -MCA(Master of Computer Application)- Software Professional with 10 years of experience.`,
  },
  {
    name: 'MR. DEEPAK SHARMA',
    role: 'ADVISOR(BUSINESS-DEVELOPMENT)',
    image: '/images/JainSira.png',
    layout: 'photo-right',
    bio: `Mr. Deepak Sharma - Advisor(Business Development) -CA, MCA, MEP(IIM Ahmedabad) with 28 years of experience .`,
  },
];

export default function OurPeoples() {
  return (
    <>
      {/* ── BANNER ── */}
      <div
        className="inner-banner"
        style={{ backgroundImage: "url('/images/ManagementsTeam-banner1.jpg')" }}
      >
        <div className="container">
          <h1>Our Management-Team</h1>
          <div className="sep" />
          <h4>Lavente Logistics.</h4>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div className="inner-bottom-sec">
        <div className="container">

          {/* SIDEBAR */}
          <div className="side-menu">
            <ul>
              {sideLinks.map((l, i) => (
                <li key={i} className={l.active ? 'active' : ''}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* MAIN CONTENT */}
          <div className="inner-main-part">

            {/* THE PEOPLE FACTOR intro */}
            <div className="inner-tp-dis">
              <h3>The People Factor</h3>
              <p>
                The quality of our manpower resources is what sets Lavente Logistics apart from others.
                Graduates, MBA's or Computer Applications, fluent in spoken and written English,
                well-versed in Industry, our people are enthusiastic, well-trained and productive.
                Our cross-functional teams have high standards of quality and stay focused on common goals.
              </p>
              <p style={{ marginTop: 14 }}>
                At Lavente Logistics , our vibrant work culture promotes drive, proactiveness, a positive
                attitude and collaborative focus to achieve common goals. Our people are selected as much
                for their domain expertise as for their dedication to quality and productivity, their
                communication and interpersonal skills Our middle managers have come up the ladder with
                Lavente Logistics and have been given the professional training and feedback to continuously
                hone their skills.
              </p>
            </div>

            {/* PEOPLE MEMBERS */}
            {peoples.map((p, i) => (
              <div
                key={i}
                className={`mgmt-member-bx ${p.layout === 'photo-right' ? 'photo-right' : ''}`}
              >
                {/* PHOTO */}
                <div className="mgmt-photo">
                  <img src={p.image} alt={p.name} className="people-avatar" />
                </div>

                {/* TEXT */}
                <div className="mgmt-info">
                  <h2 className="people-name">{p.name}</h2>
                  <h3 className="people-role">{p.role}</h3>
                  <p>{p.bio}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </>
  );
}
